/* Behaviour ported from web/src/components: Header, ScrollEffects, SmokeTransition,
   SitePopups and ProductBuyBox, plus the Shopify cart drawer. */
(function () {
  "use strict";

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  function isHome() {
    return window.location.pathname === root || window.location.pathname === root.replace(/\/$/, "");
  }

  /* ------------------------------------------------------------------ */
  /* Mobile drawer (Header.tsx)                                          */
  /* ------------------------------------------------------------------ */

  function initMobileDrawer() {
    var toggle = document.querySelector("[data-mobile-toggle]");
    var drawer = document.getElementById("mobile-nav");
    var overlay = document.querySelector("[data-mobile-overlay]");
    if (!toggle || !drawer || !overlay) return;

    function setOpen(open) {
      drawer.classList.toggle("is-open", open);
      overlay.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("overflow-hidden", open);
    }

    toggle.addEventListener("click", function () { setOpen(true); });
    overlay.addEventListener("click", function () { setOpen(false); });
    drawer.querySelectorAll("[data-mobile-close]").forEach(function (el) {
      el.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) setOpen(false);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Scroll reveal + hero parallax (ScrollEffects.tsx)                   */
  /* ------------------------------------------------------------------ */

  function initScrollEffects() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));

    if (reduceMotionQuery.matches || !("IntersectionObserver" in window)) {
      nodes.forEach(function (el) { el.classList.add("is-revealed"); });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
      );

      nodes.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
        if (inView) el.classList.add("is-revealed");
        else observer.observe(el);
      });
    }

    var heroMedia = document.querySelectorAll("[data-parallax]");
    if (!heroMedia.length) return;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        heroMedia.forEach(function (el) {
          var speed = Number(el.getAttribute("data-parallax") || "0.2");
          el.style.transform = "translate3d(0, " + y * speed + "px, 0)";
        });
        ticking = false;
      });
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* Logo smoke transition (SmokeTransition.tsx)                         */
  /* Shopify does full page loads, so the overlay is carried across the  */
  /* navigation with sessionStorage and faded out on the home page.      */
  /* ------------------------------------------------------------------ */

  var HOLD_MS = 1100;
  var FADE_MS = 450;
  var NAV_AT = Math.round(HOLD_MS * 0.55);
  var SMOKE_KEY = "sj-smoke-arrive";

  function smokeEls() {
    var overlay = document.getElementById("SmokeOverlay");
    if (!overlay) return null;
    return { overlay: overlay, videos: overlay.querySelectorAll("video") };
  }

  function startSmokeVideos(videos) {
    videos.forEach(function (v) {
      if (!v.getAttribute("src")) v.setAttribute("src", v.getAttribute("data-src"));
      try { v.currentTime = 0; } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function stopSmokeVideos(videos) {
    videos.forEach(function (v) { v.pause(); });
  }

  function leaveSmoke(els, done) {
    els.overlay.classList.remove("is-active", "is-arriving");
    els.overlay.classList.add("is-leaving");
    window.setTimeout(function () {
      els.overlay.classList.remove("is-leaving");
      stopSmokeVideos(els.videos);
      if (done) done();
    }, FADE_MS);
  }

  function initSmoke() {
    var els = smokeEls();
    var busy = false;

    // Arrival after navigating home from another page.
    if (els && document.documentElement.classList.contains("sj-smoke-arriving")) {
      busy = true;
      els.overlay.classList.add("is-active", "is-arriving");
      startSmokeVideos(els.videos);
      document.documentElement.classList.remove("sj-smoke-arriving");
      window.setTimeout(function () {
        leaveSmoke(els, function () { busy = false; });
      }, HOLD_MS - NAV_AT);
    }

    document.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("[data-smoke-home]");
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (busy) return;

      if (reduceMotionQuery.matches || !els) {
        if (!isHome()) window.location.href = root;
        else window.scrollTo({ top: 0, behavior: "auto" });
        return;
      }

      busy = true;
      els.overlay.classList.remove("is-leaving", "is-arriving");
      // Restart the CSS rise animation.
      void els.overlay.offsetWidth;
      els.overlay.classList.add("is-active");
      startSmokeVideos(els.videos);

      var goingElsewhere = !isHome();
      window.setTimeout(function () {
        if (goingElsewhere) {
          try { window.sessionStorage.setItem(SMOKE_KEY, String(Date.now())); } catch (e) {}
          window.location.href = root;
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, NAV_AT);

      if (!goingElsewhere) {
        window.setTimeout(function () {
          leaveSmoke(els, function () { busy = false; });
        }, HOLD_MS);
      }
    });

    // Back/forward cache: never leave the overlay stuck on screen.
    window.addEventListener("pageshow", function (e) {
      if (!e.persisted || !els) return;
      els.overlay.classList.remove("is-active", "is-arriving", "is-leaving");
      stopSmokeVideos(els.videos);
      busy = false;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Welcome popup + cookie bar (SitePopups.tsx)                         */
  /* ------------------------------------------------------------------ */

  var COOKIE_KEY = "sj-cookie-consent";
  var COOKIE_KEY_LEGACY = "sj-cookies-accepted";
  var WELCOME_KEY = "sj-welcome-dismissed";

  function store(fn) {
    try { return fn(window.localStorage); } catch (e) { return null; }
  }

  function readCookieConsent() {
    var value = store(function (s) { return s.getItem(COOKIE_KEY); });
    if (value === "all" || value === "essential") return value;
    if (store(function (s) { return s.getItem(COOKIE_KEY_LEGACY); }) === "1") return "all";
    return null;
  }

  function writeCookieConsent(level) {
    store(function (s) {
      s.setItem(COOKIE_KEY, level);
      s.removeItem(COOKIE_KEY_LEGACY);
    });
  }

  function applyShopifyTrackingConsent(level) {
    var allow = level === "all";
    function set() {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return false;
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: allow,
          marketing: allow,
          preferences: allow,
          sale_of_data: allow,
        },
        function () {}
      );
      return true;
    }
    if (set()) return;
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        set();
      });
    }
  }

  function initPopups() {
    var cookieBar = document.querySelector("[data-cookie-bar]");
    var welcome = document.querySelector("[data-welcome]");

    if (cookieBar) {
      var consent = readCookieConsent();
      if (consent) {
        cookieBar.hidden = true;
        applyShopifyTrackingConsent(consent);
      }
      function dismissCookies(level) {
        writeCookieConsent(level);
        applyShopifyTrackingConsent(level);
        cookieBar.hidden = true;
      }
      cookieBar.querySelectorAll("[data-cookie-accept]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          dismissCookies("all");
        });
      });
      cookieBar.querySelectorAll("[data-cookie-essential]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          dismissCookies("essential");
        });
      });
    }

    if (!welcome) return;
    var forceWelcome = new URLSearchParams(window.location.search).has("welcome");
    var welcomeDone = !forceWelcome && store(function (s) { return s.getItem(WELCOME_KEY); }) === "1";
    if (welcomeDone) return;
    if (forceWelcome) store(function (s) { s.removeItem(WELCOME_KEY); });

    function dismiss() {
      store(function (s) { s.setItem(WELCOME_KEY, "1"); });
      welcome.hidden = true;
      welcome.querySelectorAll("video").forEach(function (v) { v.pause(); });
    }

    welcome.querySelectorAll("[data-welcome-dismiss]").forEach(function (el) {
      el.addEventListener("click", dismiss);
    });

    window.setTimeout(function () {
      welcome.querySelectorAll("video").forEach(function (v) {
        if (!v.getAttribute("src")) v.setAttribute("src", v.getAttribute("data-src"));
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
      welcome.hidden = false;
    }, forceWelcome ? 200 : 1200);
  }

  /* ------------------------------------------------------------------ */
  /* Money                                                               */
  /* ------------------------------------------------------------------ */

  function formatMoney(cents, format) {
    format = format || window.SJ_MONEY_FORMAT || "£{{amount}}";
    function withDelimiters(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return withDelimiters(cents, 0, ",", ".");
        case "amount_with_comma_separator": return withDelimiters(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return withDelimiters(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return withDelimiters(cents, 2, "'", ".");
        default: return withDelimiters(cents, 2, ",", ".");
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */

  var cart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = document.getElementById("CartDrawer");
      this.overlay = document.querySelector("[data-cart-overlay]");
      var self = this;

      document.addEventListener("click", function (e) {
        var opener = e.target.closest && e.target.closest("[data-cart-open]");
        if (opener && self.drawer) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest && e.target.closest("[data-cart-close]")) {
          e.preventDefault();
          self.close();
          return;
        }
        var qtyBtn = e.target.closest && e.target.closest("[data-cart-qty]");
        if (qtyBtn) {
          e.preventDefault();
          self.change(qtyBtn.getAttribute("data-key"), Number(qtyBtn.getAttribute("data-cart-qty")));
          return;
        }
        var remove = e.target.closest && e.target.closest("[data-cart-remove]");
        if (remove) {
          e.preventDefault();
          self.change(remove.getAttribute("data-key"), 0);
        }
      });

      if (this.overlay) this.overlay.addEventListener("click", function () { self.close(); });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && self.drawer && self.drawer.classList.contains("is-open")) self.close();
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add("is-open");
      this.drawer.setAttribute("aria-hidden", "false");
      if (this.overlay) this.overlay.classList.add("is-open");
      document.body.classList.add("overflow-hidden");
      var close = this.drawer.querySelector(".cart-drawer-close");
      if (close) close.focus({ preventScroll: true });
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.classList.remove("overflow-hidden");
    },

    render: function (sections) {
      if (!sections || !sections["cart-drawer"] || !this.drawer) return;
      var doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
      var fresh = doc.getElementById("CartDrawerInner");
      var current = document.getElementById("CartDrawerInner");
      if (fresh) this.setCount(Number(fresh.getAttribute("data-cart-count-value")));
      if (fresh && current) current.replaceWith(fresh);
    },

    setCount: function (n) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = String(n);
      });
    },

    setError: function (message) {
      var el = document.querySelector("[data-cart-error]");
      if (el) el.textContent = message || "";
    },

    change: function (key, quantity) {
      var self = this;
      if (this.drawer) this.drawer.classList.add("is-busy");
      return fetch(root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ["cart-drawer"], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || "Could not update your cart.");
          self.render(res.data.sections);
        })
        .catch(function (err) { self.setError(err.message); })
        .finally(function () { if (self.drawer) self.drawer.classList.remove("is-busy"); });
    },

    add: function (form) {
      var self = this;
      var data = new FormData(form);
      data.append("sections", "cart-drawer");
      data.append("sections_url", window.location.pathname);
      return fetch(root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: data
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || "Could not add to cart.");
          self.render(res.body.sections);
          self.open();
        });
    }
  };

  /* ------------------------------------------------------------------ */
  /* Product buy box (ProductBuyBox.tsx)                                 */
  /* ------------------------------------------------------------------ */

  var STOCK_LABELS = { in_stock: "In stock", low_stock: "Low stock", out_of_stock: "Out of stock" };

  function initBuyBox(box) {
    var dataEl = box.querySelector("[data-buybox-json]");
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var selected = data.selectedOptions.slice();

    var priceEl = box.querySelector("[data-buybox-price]");
    var stockDot = box.querySelector("[data-buybox-dot]");
    var stockLabel = box.querySelector("[data-buybox-stock-label]");
    var idInput = box.querySelector("[data-buybox-id]");
    var submit = box.querySelector("[data-buybox-submit]");
    var submitLabel = box.querySelector("[data-buybox-submit-label]");
    var enquire = box.querySelector("[data-buybox-enquire]");
    var errorEl = box.querySelector("[data-buybox-error]");
    var form = box.querySelector("form[data-buybox-form]");

    function currentVariant() {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || null;
    }

    function renderPrice(v) {
      if (!priceEl) return;
      if (data.priceOnRequest || !v) {
        priceEl.className = "price price--request buybox-price";
        priceEl.textContent = "Price on request";
        return;
      }
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.className = "price buybox-price" + (onSale ? " price--sale" : "");
      var html = formatMoney(v.price);
      if (onSale) {
        html += '<span class="price__compare">' + formatMoney(v.compare_at_price) + "</span>";
        html += '<span class="badge badge--sale">Sale</span>';
      }
      priceEl.innerHTML = html;
    }

    function update() {
      var v = currentVariant();
      box.querySelectorAll("[data-option-index]").forEach(function (btn) {
        var active = selected[Number(btn.getAttribute("data-option-index"))] === btn.getAttribute("data-option-value");
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-checked", active ? "true" : "false");
      });
      renderPrice(v);

      var stock = v ? v.stock : "out_of_stock";
      if (stockDot) stockDot.className = "buybox-dot buybox-dot--" + stock;
      if (stockLabel) stockLabel.textContent = STOCK_LABELS[stock];

      if (idInput && v) idInput.value = v.id;
      if (submit) {
        var soldOut = !v || !v.available;
        submit.disabled = soldOut;
        if (submitLabel) submitLabel.textContent = soldOut ? "Sold out" : "Add to cart";
      }
      if (enquire) {
        var subject = "Enquiry: " + data.title + (data.hasVariants && v ? " (" + v.title + ")" : "");
        enquire.href = "mailto:" + data.email + "?subject=" + encodeURIComponent(subject);
        var out = stock === "out_of_stock";
        enquire.classList.toggle("buybox-disabled", out);
        enquire.textContent = out ? "Sold out" : "Enquire";
      }
      if (v && data.hasVariants && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    box.querySelectorAll("[data-option-index]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        selected[Number(btn.getAttribute("data-option-index"))] = btn.getAttribute("data-option-value");
        update();
      });
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        if (!cart.drawer) return;
        e.preventDefault();
        if (errorEl) errorEl.textContent = "";
        if (submit) submit.setAttribute("aria-busy", "true");
        cart.add(form)
          .catch(function (err) { if (errorEl) errorEl.textContent = err.message; })
          .finally(function () { if (submit) submit.removeAttribute("aria-busy"); });
      });
    }

    update();
  }

  function initProductGallery(root) {
    var main = root.querySelector("[data-product-gallery-main]");
    if (!main) return;

    var lightbox = root.closest(".wood-page") && root.closest(".wood-page").querySelector("[data-product-lightbox]");
    var lightboxImg = lightbox && lightbox.querySelector("[data-product-lightbox-image]");
    var openBtn = root.querySelector("[data-product-gallery-open]");
    var lastFocus = null;

    function fullSrc() {
      return main.getAttribute("data-gallery-full") || main.currentSrc || main.src;
    }

    function select(thumb) {
      var src = thumb.getAttribute("data-gallery-src");
      if (!src) return;
      main.src = src;
      main.removeAttribute("srcset");
      main.removeAttribute("sizes");
      var full = thumb.getAttribute("data-gallery-full");
      if (full) main.setAttribute("data-gallery-full", full);
      root.querySelectorAll("[data-product-gallery-thumb]").forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (lightbox && !lightbox.hidden && lightboxImg) {
        lightboxImg.src = fullSrc();
        lightboxImg.alt = main.alt || "";
      }
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      lightbox.setAttribute("aria-hidden", "true");
      document.body.classList.remove("product-lightbox-open");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      lastFocus = document.activeElement;
      lightboxImg.src = fullSrc();
      lightboxImg.alt = main.alt || "";
      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden", "false");
      document.body.classList.add("product-lightbox-open");
      var close = lightbox.querySelector("[data-product-lightbox-close]");
      if (close) close.focus();
    }

    root.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-product-gallery-thumb]");
      if (thumb && root.contains(thumb)) {
        e.preventDefault();
        select(thumb);
        return;
      }
      if (e.target.closest("[data-product-gallery-open]")) {
        e.preventDefault();
        openLightbox();
      }
    });

    if (lightbox) {
      lightbox.querySelectorAll("[data-product-lightbox-close]").forEach(function (el) {
        el.addEventListener("click", function () {
          closeLightbox();
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !lightbox.hidden) closeLightbox();
      });
    }
  }

  /* ------------------------------------------------------------------ */

  function init() {
    document.documentElement.classList.remove("no-js");
    initMobileDrawer();
    initScrollEffects();
    initSmoke();
    initPopups();
    cart.init();
    document.querySelectorAll("[data-product-gallery]").forEach(initProductGallery);
    document.querySelectorAll("[data-buybox]").forEach(initBuyBox);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
